module.exports = __webpack_public_path__ + "img/lotion-bottle.03570bbf.png";